import React from 'react';
import HeaderContainer from '../../containers/common/HeaderContainer';
import Navigation from '../../components/common/Navigation';
import { SideSpacer } from '../../components/common/Spacer';import {
  HorizonWrapper,
} from '../../components/common/Container';
import {
  CommonContainer,
} from '../../components/common/Container';
import BuyContainer from '../../containers/buy/BuyContainer';

const BuyPage = () => {
    
  return (
    <>
      <HeaderContainer />
      <Navigation />
      <SideSpacer>
      <HorizonWrapper>
        <CommonContainer>
          <BuyContainer />
        </CommonContainer>
      </HorizonWrapper>
      </SideSpacer>
    </>
  );
};

export default BuyPage;
